export const CardUserWallet = ({ wallet }) => {
  return (
    <div className="ui-card">
      <div style={{ display: "flex", alignItems: "center", gap: 9, marginBottom: 16 }}>
        <i className="ri-wallet-3-line" style={{ color: "#4B36F0", fontSize: 17 }} />
        <h3 style={{ margin: 0, fontSize: 15, fontWeight: 700 }}>Billetera</h3>
      </div>

      {!wallet ? (
        <p style={{ margin: 0, color: "#8A91AE", fontSize: 12.5 }}>El usuario no tiene billetera registrada.</p>
      ) : (
        <div className="ui-kv">
          <div className="ui-kv__row">
            <span className="ui-kv__label">Cuenta desde</span>
            <span className="ui-kv__value">
              {wallet.createdAt ? new Date(wallet.createdAt).toLocaleDateString() : "-"}
            </span>
          </div>
          <div className="ui-kv__row">
            <span className="ui-kv__label">Movimientos</span>
            <span className="ui-kv__value">{wallet.history?.length ?? 0}</span>
          </div>
          <div className="ui-kv__row">
            <span className="ui-kv__label">Saldo disponible</span>
            <span className="ui-kv__value--muted">No disponible</span>
          </div>
        </div>
      )}
    </div>
  );
};
